export enum Project {
  Biomasser = 'biomasser',
  Tomasser = 'tomasser',
}
